<div *ngIf="isPageReady" class="flex flex-col h-full">
  <!-- Summary Card -->
  <div class="grid grid-cols-12 gap-4 p-4 shrink-0">
    <div class="col-span-12 qb-detail-card qb-primary-tint p-4">
      <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Add-On Summary</div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-2">
          <div class="text-sm text-gray-500">Ship Bin</div>
          <div class="font-semibold text-lg">{{ shipBin.id }}</div>
        </div>
        <div class="col-span-3">
          <div class="text-sm text-gray-500">Expected Ship Date</div>
          <div>{{ shipBin.expectedShipDate | date:'MM/dd/yyyy' }}</div>
        </div>
        <div class="col-span-2">
          <div class="text-sm text-gray-500">Add-On Items</div>
          <div class="font-semibold">{{ totalItemCount }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Add-On Items Grid -->
  <div class="flex-1 min-h-0 mx-4">
    <app-ag-grid [gridOptions]="addonGridOptions" [rowData]="addonItems" class="h-full"></app-ag-grid>
  </div>

  <!-- Footer Buttons -->
  <div class="flex justify-end gap-2 p-3 border-t shrink-0">
    <button pButton type="button" class="p-button-raised" (click)="onClose()">
      <span>Close</span>
    </button>
  </div>
</div>
